<template>
  <div class="store-report">
    <!-- 报告类型切换 -->
    <div class="report-type-group">
      <el-radio-group v-model="reportType" size="small" @change="onReportTypeChange">
        <el-radio-button v-for="item in reportTypeOptions" :key="item.value" :label="item.value">{{ item.label }}</el-radio-button>
      </el-radio-group>
    </div>
    
    <!-- 报告卡片容器 -->
    <div class="report-card">
    <!-- 页面头部 -->
    <div class="page-header">
      <div class="header-left">
        <div class="header-icon-gradient">
          <svg class="header-icon-svg" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path></svg>
        </div>
        <h2>单店报告成绩</h2>
        <!-- 月度模式：单选波次 + 问卷 -->
        <template v-if="reportType === 1">
          <el-select v-model="waveId" placeholder="请选择波次" class="header-select" @change="onWaveChange">
            <el-option v-for="w in allWaveList" :key="w.id" :label="w.name" :value="w.id" />
          </el-select>
          <el-select v-model="formKey" placeholder="请选择问卷" class="header-select" @change="onFormChange" style="margin-left:10px;" v-if="formList.length">
            <el-option v-for="form in formList" :key="getFormKey(form)" :label="stripHtml(form.name)" :value="getFormKey(form)" />
          </el-select>
        </template>
        <!-- 多波次模式：波次多选下拉 + 问卷多选下拉 -->
        <template v-else>
          <el-select v-model="selectedWaveIds" multiple collapse-tags placeholder="选择波次" class="header-select" @change="onMultiWaveChange" style="min-width:200px;">
            <el-option v-for="w in allWaveList" :key="w.id" :label="w.name" :value="w.id" />
          </el-select>
          <el-select v-model="selectedFormKey" placeholder="选择问卷" class="header-select" @change="onMultiFormChange" style="min-width:200px; margin-left:10px;" v-if="multiFormList.length">
            <el-option v-for="f in multiFormList" :key="getFormKey(f)" :label="stripHtml(f.name)" :value="getFormKey(f)" />
          </el-select>
        </template>
      </div>
      <div class="header-right">
        <el-input 
          v-model="filterKeyword" 
          placeholder="搜索区域/门店名称" 
          prefix-icon="el-icon-search" 
          class="header-search"
          clearable
          @input="handleFilter"
        />
        <el-button type="primary" class="btn-generate" :loading="generating" @click="generateReport">
          <svg class="btn-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path></svg>
          生成/更新统计
        </el-button>
        <el-button class="btn-export" @click="exportExcel">
          <svg class="btn-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path></svg>
          导出
        </el-button>
        <el-button v-if="snapshotInfo && snapshotInfo.isPublished" class="btn-publish" :loading="publishing" @click="unpublishReport">
          <i class="el-icon-circle-close"></i> 取消发布
        </el-button>
        <el-button v-else class="btn-publish" :loading="publishing" @click="publishReport">
          <svg class="btn-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path></svg>
          发布
        </el-button>
        <el-button class="btn-refresh-icon" @click="loadData">
          <svg class="refresh-icon-svg" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path></svg>
        </el-button>
      </div>
    </div>
    
    <!-- 快照信息 -->
    <div class="snapshot-info" v-if="snapshotInfo">
      <i class="el-icon-time"></i>
      数据更新时间: {{ snapshotInfo.generateTime | formatTime }}
      <span style="margin-left: 15px">统计门店数: {{ snapshotInfo.storeCount }}</span>
      <el-tag v-if="snapshotInfo.isPublished" type="success" size="small" style="margin-left: 15px">已发布</el-tag>
      <el-tag v-else type="info" size="small" style="margin-left: 15px">未发布</el-tag>
    </div>

    <!-- 统计概览 -->
    <div class="stats-bar" v-if="nationalData">
      <div class="stat-card">
        <div class="stat-value">{{ nationalData.avgScore || 0 }}</div>
        <div class="stat-label">全国平均分</div>
      </div>
      <div class="stat-card">
        <div class="stat-value">{{ nationalData.storeCount || 0 }}</div>
        <div class="stat-label">覆盖门店数</div>
      </div>
      <div class="stat-card" v-if="reportType > 1">
        <div class="stat-value">{{ snapshotInfo ? snapshotInfo.waveCount : selectedWaveIds.length }}</div>
        <div class="stat-label">涉及波次数</div>
      </div>
      <div class="stat-card" v-if="reportType > 1">
        <div class="stat-value">
          <el-tag size="small" :type="reportType === 2 ? 'warning' : reportType === 3 ? 'danger' : 'info'">{{ reportTypeLabel }}</el-tag>
        </div>
        <div class="stat-label">报告类型</div>
      </div>
    </div>

    <!-- 统一数据表格 -->
    <div class="report-content" v-if="formKey || (reportType > 1 && selectedWaveIds.length > 0)">
      <el-table 
        :data="displayData" 
        stripe 
        v-loading="loading" 
        row-key="uniqueId"
        border
        class="custom-table"
        header-row-class-name="table-header"
        @expand-change="handleExpandChange"
      >
        <!-- 展开列：显示环节详情 -->
        <el-table-column type="expand" width="50">
          <template slot-scope="{ row }">
            <div class="expand-wrapper" v-loading="row.detailLoading">
              <!-- 详情标题 -->
              <div class="detail-header">
                <span class="detail-title">
                  <i class="el-icon-s-data"></i> 
                  {{ row.name }} - 环节得分详情
                  <span class="detail-tag" v-if="row.rowType === 'store'"> (总分: {{ row.avgScore }})</span>
                  <span class="detail-tag" v-else> (平均分: {{ row.avgScore }})</span>
                </span>
                <span class="detail-subtitle" v-if="row.rowType === 'store'">
                  排位情况: 
                  在小区 #{{ row.rankInXiaoqu || '-' }} / 
                  在大区 #{{ row.xiaoquRankInDaqu || '-' }} / 
                  在全国 #{{ row.daquRankInNational || '-' }}
                </span>
              </div>
              
              <!-- 算法说明 -->
              <div class="algorithm-note">
                <i class="el-icon-info"></i>
                <span v-if="row.rowType === 'national'">
                  <strong>全国汇总：</strong>各环节得分 = 所有门店该环节得分的<strong>平均值</strong>
                </span>
                <span v-else-if="row.rowType === 'daqu'">
                  <strong>战区汇总：</strong>各环节得分 = 本战区所有门店该环节得分的<strong>平均值</strong>
                </span>
                <span v-else-if="row.rowType === 'xiaoqu'">
                  <strong>小区汇总：</strong>各环节得分 = 本小区所有门店该环节得分的<strong>平均值</strong>
                </span>
                <span v-else>
                  <strong>门店明细：</strong>各环节得分 = 该门店各题目得分的<strong>实际汇总</strong>
                </span>
              </div>
              
              <!-- 环节得分表格 -->
              <div class="segment-table-container">
                <table class="segment-table">
                  <thead>
                    <tr>
                      <th style="width: 35%">环节名称</th>
                      <th style="width: 12%" class="text-center">算分方式</th>
                      <th style="width: 13%" class="text-center">标准分</th>
                      <th style="width: 13%" class="text-center">实际得分</th>
                      <th style="width: 13%" class="text-center">得分率</th>
                      <th style="width: 14%" class="text-center">状态</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="seg in row.segmentTree">
                      <tr :key="seg.segmentKey" class="level-1" @click="toggleSegmentExpand(seg)">
                        <td class="col-name">
                          <span class="expand-icon">{{ seg.expanded === false ? '[+]' : '[-]' }}</span>
                          <span class="icon">📂</span>
                          {{ seg.segmentName }}
                        </td>
                        <td class="text-center"><span class="score-method-tag">{{ scoreMethodLabel(seg.scoreMethod || seg.ScoreMethod) }}</span></td>
                        <td class="text-center">{{ seg.targetScore }}</td>
                        <td class="text-center">{{ seg.actualScore }}</td>
                        <td class="text-center">{{ seg.scoreRate }}%</td>
                        <td class="text-center">{{ getStatusIcon(seg.scoreRate) }}</td>
                      </tr>
                      <template v-if="seg.expanded !== false && seg.children && seg.children.length">
                        <template v-for="child in seg.children">
                          <tr :key="child.segmentKey" class="level-2" @click="toggleSegmentExpand(child)">
                            <td class="col-name">
                              <span class="indent-2"></span>
                              <span v-if="(child.children && child.children.length) || (child.items && child.items.length)" class="expand-icon">{{ child.expanded === false ? '[+]' : '[-]' }}</span>
                              <span class="icon">📁</span>
                              {{ child.segmentName }}
                              <span v-if="child.itemCount" class="item-count">({{ child.itemCount }}题)</span>
                            </td>
                            <td class="text-center">{{ child.targetScore }}</td>
                            <td class="text-center">{{ child.actualScore }}</td>
                            <td class="text-center">{{ child.scoreRate }}%</td>
                            <td class="text-center">{{ getStatusIcon(child.scoreRate) }}</td>
                          </tr>
                          <!-- 如果二级有三级children，渲染三级 -->
                          <template v-if="child.expanded !== false && child.children && child.children.length">
                            <template v-for="leaf in child.children">
                              <tr :key="leaf.segmentKey" class="level-3" @click="toggleSegmentExpand(leaf)">
                                <td class="col-name">
                                  <span class="indent-3"></span>
                                  <span v-if="leaf.items && leaf.items.length" class="expand-icon">{{ leaf.expanded === false ? '[+]' : '[-]' }}</span>
                                  <span class="icon">📄</span>
                                  {{ leaf.segmentName }}
                                  <span v-if="leaf.itemCount" class="item-count">({{ leaf.itemCount }}题)</span>
                                </td>
                                <td class="text-center">{{ leaf.targetScore }}</td>
                                <td class="text-center">{{ leaf.actualScore }}</td>
                                <td class="text-center">{{ leaf.scoreRate }}%</td>
                                <td class="text-center">{{ getStatusIcon(leaf.scoreRate) }}</td>
                              </tr>
                              <!-- 三级的题目列表 -->
                              <template v-if="leaf.expanded !== false && leaf.items && leaf.items.length">
                                <tr v-for="item in leaf.items" :key="item.itemKey" class="level-item">
                                  <td class="col-name item-row">
                                    <span class="indent-4"></span>
                                    <span class="icon">📝</span>
                                    <span class="item-label" v-html="stripHtml(item.label)"></span>
                                  </td>
                                  <td class="text-center item-row">{{ item.targetScore || '-' }}</td>
                                  <td class="text-center item-row">{{ item.actualScore }}</td>
                                  <td class="text-center item-row">{{ item.scoreRate }}%</td>
                                  <td class="text-center item-row">{{ getStatusIcon(item.scoreRate) }}</td>
                                </tr>
                              </template>
                            </template>
                          </template>
                          <!-- 如果二级没有三级children，直接显示二级的items -->
                          <template v-if="child.expanded !== false && (!child.children || child.children.length === 0) && child.items && child.items.length">
                            <tr v-for="item in child.items" :key="item.itemKey" class="level-item">
                              <td class="col-name item-row">
                                <span class="indent-3"></span>
                                <span class="icon">📝</span>
                                <span class="item-label" v-html="stripHtml(item.label)"></span>
                              </td>
                              <td class="text-center item-row">{{ item.targetScore || '-' }}</td>
                              <td class="text-center item-row">{{ item.actualScore }}</td>
                              <td class="text-center item-row">{{ item.scoreRate }}%</td>
                              <td class="text-center item-row">{{ getStatusIcon(item.scoreRate) }}</td>
                            </tr>
                          </template>
                        </template>
                      </template>
                      <!-- 如果一级没有子环节children，直接显示一级的items -->
                      <template v-if="seg.expanded !== false && (!seg.children || seg.children.length === 0) && seg.items && seg.items.length">
                        <tr v-for="item in seg.items" :key="item.itemKey" class="level-item">
                          <td class="col-name item-row">
                            <span class="indent-2"></span>
                            <span class="icon">📝</span>
                            <span class="item-label" v-html="stripHtml(item.label)"></span>
                          </td>
                          <td class="text-center item-row">{{ item.targetScore || '-' }}</td>
                          <td class="text-center item-row">{{ item.actualScore }}</td>
                          <td class="text-center item-row">{{ item.scoreRate }}%</td>
                          <td class="text-center item-row">{{ getStatusIcon(item.scoreRate) }}</td>
                        </tr>
                      </template>
                    </template>
                    <tr v-if="!row.segmentTree || row.segmentTree.length === 0">
                      <td colspan="5" class="text-center text-muted" style="padding: 20px;">暂无详情数据</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="类型" width="80" align="center">
          <template slot-scope="{ row }">
            <el-tag v-if="row.rowType === 'national'" size="mini" type="danger">全国</el-tag>
            <el-tag v-else-if="row.rowType === 'daqu'" size="mini" type="warning">战区</el-tag>
            <el-tag v-else-if="row.rowType === 'xiaoqu'" size="mini" type="success">小区</el-tag>
            <el-tag v-else size="mini" type="info">门店</el-tag>
          </template>
        </el-table-column>
        
        <el-table-column label="名称" min-width="200">
          <template slot-scope="{ row }">
            <span :class="'row-type-' + row.rowType" class="name-cell">
              <span v-if="row.rowType === 'national'" class="type-icon">🌏</span>
              <span v-else-if="row.rowType === 'daqu'" class="type-icon">🏢</span>
              <span v-else-if="row.rowType === 'xiaoqu'" class="type-icon">🏠</span>
              <span v-else class="type-icon">🏪</span>
              
              <span class="name-text">{{ row.name }}</span>
              <el-tag v-if="row.rowType === 'store' && row.code" size="mini" type="info" style="margin-left: 8px">{{ row.code }}</el-tag>
            </span>
          </template>
        </el-table-column>
        
        <el-table-column label="门店数" prop="storeCount" width="100" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.rowType !== 'store'">{{ row.storeCount }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        
        <el-table-column label="总体得分" width="140" align="center">
          <template slot="header">
            总体得分
            <el-tooltip content="全国/战区/小区显示的是下级数据的平均分" placement="top">
              <i class="el-icon-info" style="color: #909399; cursor: help; margin-left: 4px;"></i>
            </el-tooltip>
          </template>
          <template slot-scope="{ row }">
            <span :class="getScoreClass(row.avgScore)" class="score-text">
              {{ row.avgScore }}
              <span v-if="row.rowType !== 'store'" style="font-size: 11px; color: #909399;"> (均值)</span>
            </span>
          </template>
        </el-table-column>
        
        <el-table-column label="全国排名" width="100" align="center">
          <template slot-scope="{ row }">
             <!-- 门店显示全国排名，区域显示区域排名 -->
             <span v-if="row.rowType === 'store'">{{ row.daquRankInNational || '-' }}</span>
             <span v-else-if="row.rowType === 'daqu'">{{ row.rank }}/{{ row.rankTotal }}</span>
             <span v-else>-</span>
          </template>
        </el-table-column>
        
        <el-table-column label="战区排名" width="100" align="center">
          <template slot-scope="{ row }">
             <span v-if="row.rowType === 'store'">{{ row.xiaoquRankInDaqu || '-' }}</span>
             <span v-else-if="row.rowType === 'xiaoqu'">{{ row.rank }}/{{ row.rankTotal }}</span>
             <span v-else>-</span>
          </template>
        </el-table-column>
        
        <!-- 一级指标列 (动态) -->
        <el-table-column v-for="col in topLevelSegments" :key="col.segmentKey" :label="col.segmentName" width="120" align="center">
           <template slot-scope="{ row }">
             {{ getSegmentScore(row, col.segmentKey) }}
           </template>
        </el-table-column>
        
      </el-table>
    </div>
    
    <div class="empty-tip" v-else>
      <i class="el-icon-document-copy"></i>
      <p>请选择一个问卷查看报告</p>
    </div>

    </div><!-- /report-card -->

    <!-- 发布报告弹窗 -->
    <el-dialog 
      title="发布报告" 
      :visible.sync="publishDialogVisible" 
      width="460px"
      custom-class="publish-dialog"
      :close-on-click-modal="false"
    >
      <div class="publish-form">
        <div class="publish-form-row">
          <span class="publish-label">当前问卷</span>
          <span class="publish-value">{{ currentFormName }}</span>
        </div>
        <div class="publish-form-row">
          <span class="publish-label required">选择波次</span>
          <el-select v-model="publishWaveId" placeholder="请选择要发布的波次" class="publish-select">
            <el-option 
              v-for="wave in waveListForPublish" 
              :key="wave.id" 
              :label="wave.name" 
              :value="wave.id"
            />
          </el-select>
          <div v-if="waveListForPublish.length === 0" class="publish-tip">
            该问卷未关联任何波次，请先在波次管理中关联
          </div>
        </div>
      </div>
      <div slot="footer" class="publish-footer">
        <el-button class="publish-btn-cancel" @click="publishDialogVisible = false">取消</el-button>
        <el-button type="primary" class="publish-btn-confirm" :loading="publishing" :disabled="!publishWaveId" @click="confirmPublish">确定发布</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'index/axios'
import { getProjectForms } from '@/app/index/api/project/manager'
import { getWaveList } from 'index/api/project/wave'
import * as XLSX from 'xlsx'

export default {
  name: 'StoreReport',
  data() {
    return {
      projectId: this.$route.params.projectId,
      formKey: '',
      waveId: '',
      allFormList: [],
      formList: [],
      allWaveList: [],
      loading: false,
      generating: false,
      publishing: false,
      publishDialogVisible: false,
      publishWaveId: '',
      waveListForPublish: [],
      filterKeyword: '',
      
      // 多波次聚合
      reportType: 1, // 1=月度 2=季度 3=年度 4=自定义
      selectedWaveIds: [],
      selectedFormKey: '', // 多波次模式下选中的问卷key
      multiFormList: [], // 多波次模式下可选问卷列表
      reportTypeOptions: [
        { label: '月度报告', value: 1 },
        { label: '季度报告', value: 2 },
        { label: '年度报告', value: 3 },
        { label: '自定义', value: 4 }
      ],
      
      // 原始数据
      rawData: [], // 树形结构
      displayData: [], // 经过筛选的树
      
      nationalData: null,
      topLevelSegments: [],
      snapshotInfo: null // 快照信息
    }
  },
  filters: {
    formatTime(val) {
      if (!val) return '-'
      const d = new Date(val)
      return d.toLocaleString('zh-CN')
    }
  },
  computed: {
    currentFormName() {
      if (!this.formKey || !this.formList.length) return '-'
      const form = this.formList.find(f => this.getFormKey(f) === this.formKey)
      return form ? this.stripHtml(form.name) : this.formKey
    },
    reportTypeLabel() {
      const opt = this.reportTypeOptions.find(o => o.value === this.reportType)
      return opt ? opt.label : ''
    }
  },
  created() {
    this.loadInitData()
  },
  methods: {
    async loadInitData() {
      try {
        // 同时加载波次和问卷
        const [waveRes, formRes] = await Promise.all([
          getWaveList(this.projectId),
          getProjectForms(this.projectId)
        ])
        const waveWrapper = waveRes.data?.data || waveRes.data || waveRes
        this.allWaveList = waveWrapper.rows || waveWrapper.Rows || (Array.isArray(waveWrapper) ? waveWrapper : [])
        this.allFormList = formRes.data?.data || formRes.data || []
        
        // 自动选第一个波次
        if (this.allWaveList.length > 0) {
          this.waveId = this.allWaveList[0].id
          this.onWaveChange()
        }
      } catch (e) {
        console.error('[StoreReport] loadInitData error:', e)
      }
    },
    
    getFormKey(form) {
      return form.formKey || form.key || form.sourceId || form.source_id || ''
    },
    
    stripHtml(html) {
      if (!html) return ''
      return html.replace(/<[^>]*>/g, '')
    },
    
    onWaveChange() {
      // 根据选中的波次，只取第三阶段的问卷
      const wave = this.allWaveList.find(w => w.id === this.waveId)
      if (!wave) { this.formList = []; this.formKey = ''; return }
      const phases = wave.Phases || wave.phases || []
      const formIdSet = new Set()
      phases.forEach(p => {
        const phaseNo = parseInt(p.phaseNo || p.PhaseNo || 0)
        if (phaseNo === 3) {
          const fid = String(p.formId || p.FormId || '')
          if (fid) formIdSet.add(fid)
        }
      })
      this.formList = this.allFormList.filter(f => formIdSet.has(String(f.id || '')))
      // 自动选择第一个问卷
      if (this.formList.length > 0) {
        this.formKey = this.getFormKey(this.formList[0])
        this.loadData()
      } else {
        this.formKey = ''
        this.rawData = []; this.displayData = []; this.nationalData = null
      }
    },
    
    onFormChange() {
      try { localStorage.setItem(`store_report_formKey_${this.projectId}`, this.formKey) } catch {}
      this.loadData()
    },
    
    onReportTypeChange(val) {
      this.reportType = val
      this.rawData = []; this.displayData = []; this.nationalData = null; this.snapshotInfo = null
      if (val === 1) {
        // 切回月度，恢复单选
        this.selectedWaveIds = []
        this.selectedFormKey = ''
        this.multiFormList = []
        if (this.waveId) this.onWaveChange()
      } else {
        // 多波次模式
        this.formKey = ''
        if (val === 2) {
          // 季度：自动选最近3个
          this.selectedWaveIds = this.allWaveList.slice(0, 3).map(w => w.id)
        } else if (val === 3) {
          // 年度：全选
          this.selectedWaveIds = this.allWaveList.map(w => w.id)
        }  // 自定义：用户手选
        this.updateMultiFormList()
        if (this.selectedWaveIds.length > 0 && this.selectedFormKey) this.loadData()
      }
    },
    
    /** 根据选中的波次，计算可用问卷列表（并集） */
    updateMultiFormList() {
      const formIdSet = new Set()
      this.selectedWaveIds.forEach(wid => {
        const wave = this.allWaveList.find(w => w.id === wid)
        if (!wave) return
        const phases = wave.Phases || wave.phases || []
        phases.forEach(p => {
          const fid = String(p.formId || p.FormId || '')
          if (fid) formIdSet.add(fid)
        })
      })
      this.multiFormList = this.allFormList.filter(f => formIdSet.has(String(f.id || '')))
      // 默认选第一个
      if (this.multiFormList.length > 0) {
        this.selectedFormKey = this.getFormKey(this.multiFormList[0])
      } else {
        this.selectedFormKey = ''
      }
    },
    
    onMultiWaveChange() {
      this.updateMultiFormList()
      if (this.selectedWaveIds.length > 0 && this.selectedFormKey) {
        this.loadData()
      } else {
        this.rawData = []; this.displayData = []; this.nationalData = null
      }
    },
    
    onMultiFormChange() {
      if (this.selectedWaveIds.length > 0 && this.selectedFormKey) {
        this.loadData()
      } else {
        this.rawData = []; this.displayData = []; this.nationalData = null
      }
    },
    
    async loadData() {
      // 月度模式需要 formKey，多波次模式需要 selectedWaveIds
      if (this.reportType === 1 && !this.formKey) return
      if (this.reportType > 1 && this.selectedWaveIds.length === 0) return
      this.loading = true
      try {
        // 构建请求参数
        const params = {
          ProjectId: this.projectId,
          ReportType: this.reportType
        }
        if (this.reportType === 1) {
          params.FormKey = this.formKey
          params.WaveId = this.waveId || undefined
        } else {
          params.WaveIds = this.selectedWaveIds
          if (this.selectedFormKey) {
            params.FormKeys = [this.selectedFormKey]
          }
        }
        
        // Step 1: 尝试从快照加载
        const snapshotRes = await axios.post('/Report/snapshot', params)
        const snapshotWrapper = snapshotRes.data || snapshotRes
        const snapshotData = snapshotWrapper.data || snapshotWrapper
        
        if (snapshotData && snapshotData.hasSnapshot && snapshotData.data) {
          // 使用快照数据
          this.snapshotInfo = {
            generateTime: snapshotData.generateTime,
            storeCount: snapshotData.storeCount,
            isPublished: snapshotData.isPublished || false,
            publishTime: snapshotData.publishTime
          }
          this.processRegionalData(snapshotData.data)
          return
        }
        
        // Step 2: 无快照
        this.snapshotInfo = null
        
        if (this.reportType > 1) {
          // 多波次模式没有实时计算接口，需先生成快照
          this.$message.info('尚未生成该报告，请点击"生成/更新统计"按钮')
          return
        }
        
        // 月度模式：实时计算
        const res = await axios.post('/Report/regional', params)
        const wrapper = res.data || res
        const data = wrapper.data || wrapper
        
        if (data && !data.errcode) {
          this.processRegionalData(data)
        }
      } catch (e) {
        console.error('[StoreReport] Load data error:', e)
        if (this.reportType > 1) {
          this.$message.info('尚未生成该报告，请点击"生成/更新统计"按钮')
        } else {
          this.$message.error('加载数据失败')
        }
      } finally {
        this.loading = false
      }
    },
    
    processRegionalData(data) {
      // 兼容 PascalCase 和 camelCase
      const national = data.national || data.National
      const daquRows = data.daquRows || data.DaquRows || []
      const segmentColumns = data.segmentColumns || data.SegmentColumns || []
      
      this.nationalData = national
      this.topLevelSegments = segmentColumns.filter(s => stringIsNullOrEmpty(s.parentKey || s.ParentKey))
      
      if (!this.nationalData) {
         this.rawData = []
         this.displayData = []
         return
      }
      
      // 辅助函数：移除 children 属性
      const stripChildren = (obj) => {
        const { children, Children, ...rest } = obj
        return rest
      }
      
      // 构建平铺数据 (Flat List) - 全部平行展示
      const flatList = []
      
      // 1. 添加全国
      flatList.push({
        ...stripChildren(this.nationalData),
        uniqueId: 'national_0',
        rowType: 'national',
        name: this.nationalData.name || this.nationalData.Name || '全国',
        avgScore: this.nationalData.avgScore || this.nationalData.AvgScore || 0,
        storeCount: this.nationalData.storeCount || this.nationalData.StoreCount || 0
      })
      
      // 2. 添加所有战区(大区)
      daquRows.forEach(daqu => {
        flatList.push({
          ...stripChildren(daqu),
          uniqueId: `daqu_${daqu.id || daqu.Id}`,
          rowType: 'daqu',
          name: daqu.name || daqu.Name,
          avgScore: daqu.avgScore || daqu.AvgScore,
          storeCount: daqu.storeCount || daqu.StoreCount,
          rank: daqu.rank || daqu.Rank,
          rankTotal: daqu.rankTotal || daqu.RankTotal
        })
      })
      
      // 3. 添加所有小区
      daquRows.forEach(daqu => {
        const children = daqu.children || daqu.Children || []
        children.forEach(xiaoqu => {
          flatList.push({
            ...stripChildren(xiaoqu),
            uniqueId: `xiaoqu_${xiaoqu.id || xiaoqu.Id}`,
            rowType: 'xiaoqu',
            name: xiaoqu.name || xiaoqu.Name,
            avgScore: xiaoqu.avgScore || xiaoqu.AvgScore,
            storeCount: xiaoqu.storeCount || xiaoqu.StoreCount,
            rank: xiaoqu.rank || xiaoqu.Rank,
            rankTotal: xiaoqu.rankTotal || xiaoqu.RankTotal,
            parentDaquName: daqu.name || daqu.Name
          })
        })
      })
      
      // 4. 添加所有门店
      daquRows.forEach(daqu => {
        const daquChildren = daqu.children || daqu.Children || []
        daquChildren.forEach(xiaoqu => {
          const xiaoquChildren = xiaoqu.children || xiaoqu.Children || []
          xiaoquChildren.forEach(store => {
            flatList.push({
              ...stripChildren(store),
              uniqueId: `store_${store.id || store.Id}`,
              code: store.storeCode || store.StoreCode || store.code || store.Code,
              rowType: 'store',
              name: store.name || store.Name,
              avgScore: store.avgScore || store.AvgScore,
              parentXiaoquName: xiaoqu.name || xiaoqu.Name,
              parentDaquName: daqu.name || daqu.Name,
              daquRankInNational: store.daquRankInNational || store.DaquRankInNational,
              xiaoquRankInDaqu: store.xiaoquRankInDaqu || store.XiaoquRankInDaqu,
              rankInXiaoqu: store.rankInXiaoqu || store.RankInXiaoqu || store.rank || store.Rank
            })
          })
        })
      })
      
      
      this.rawData = flatList
      this.handleFilter()
    },
    
    async generateReport() {
      if (this.reportType === 1 && !this.formKey) {
        this.$message.warning('请先选择问卷')
        return
      }
      if (this.reportType > 1 && this.selectedWaveIds.length === 0) {
        this.$message.warning('请先选择波次')
        return
      }
      this.generating = true
      try {
        const params = {
          ProjectId: this.projectId,
          ReportType: this.reportType
        }
        if (this.reportType === 1) {
          params.FormKey = this.formKey
        } else {
          params.WaveIds = this.selectedWaveIds
        }
        const res = await axios.post('/Report/generate', params)
        const data = res.data?.data || res.data
        if (data && !data.errcode) {
          const typeLabel = this.reportTypeLabel || '月度报告'
          this.$message.success(`${typeLabel}生成成功，共 ${data.storeCount || 0} 家门店`)
          // 重新加载数据
          await this.loadData()
        } else {
          this.$message.error(data?.message || '生成失败')
        }
      } catch (e) {
        console.error(e)
        this.$message.error('生成失败')
      } finally {
        this.generating = false
      }
    },
    
    async publishReport() {
      if (this.reportType === 1 && !this.formKey) {
        this.$message.warning('请先选择问卷')
        return
      }
      if (this.reportType > 1 && this.selectedWaveIds.length === 0) {
        this.$message.warning('请先选择波次')
        return
      }
      if (this.reportType > 1) {
        // 多波次模式直接发布，不需要选波次
        this.publishing = true
        try {
          const res = await axios.post('/Report/publish', {
            ProjectId: this.projectId,
            FormKey: `multi_${this.selectedWaveIds.sort((a,b)=>a-b).join('_')}`,
            WaveId: this.selectedWaveIds[0],
            WaveIds: this.selectedWaveIds,
            ReportType: this.reportType
          })
          const data = res.data?.data || res.data
          if (data && !data.errcode) {
            this.$message.success('发布成功')
            if (this.snapshotInfo) {
              this.snapshotInfo.isPublished = true
            }
          } else {
            this.$message.error(data?.message || '发布失败')
          }
        } catch (e) {
          this.$message.error('发布失败')
        } finally {
          this.publishing = false
        }
        return
      }
      // 月度模式：保持现有逻辑
      const currentForm = this.formList.find(f => this.getFormKey(f) === this.formKey)
      const currentFormId = currentForm ? String(currentForm.id || '') : ''
      try {
        const res = await getWaveList(this.projectId)
        const wrapper = res.data?.data || res.data || res
        const allWaves = wrapper.rows || wrapper.Rows || (Array.isArray(wrapper) ? wrapper : [])
        this.waveListForPublish = allWaves.filter(w => {
          const fk = w.formKeys || w.FormKeys || []
          if (Array.isArray(fk)) {
            return fk.some(id => String(id) === currentFormId)
          }
          const str = String(fk).trim()
          if (str.startsWith('[')) {
            try {
              const arr = JSON.parse(str)
              return arr.some(p => String(p.formId || p) === currentFormId)
            } catch { return false }
          }
          return str.split(',').some(id => id.trim() === currentFormId)
        })
      } catch (e) {
        console.error(e)
        this.waveListForPublish = []
      }
      this.publishWaveId = this.waveListForPublish.length === 1 ? this.waveListForPublish[0].id : ''
      this.publishDialogVisible = true
    },
    
    async confirmPublish() {
      if (!this.publishWaveId) {
        this.$message.warning('请选择波次')
        return
      }
      this.publishing = true
      try {
        const res = await axios.post('/Report/publish', {
          ProjectId: this.projectId,
          FormKey: this.formKey,
          WaveId: this.publishWaveId
        })
        const data = res.data?.data || res.data
        if (data && !data.errcode) {
          this.$message.success('发布成功，客户门户已可查看')
          this.publishDialogVisible = false
          // 直接更新发布状态，避免 loadData 重置展开的门店详情
          if (this.snapshotInfo) {
            this.snapshotInfo.isPublished = true
            this.snapshotInfo.publishTime = new Date().toISOString()
          }
        } else {
          this.$message.error(data?.message || '发布失败')
        }
      } catch (e) {
        console.error(e)
        this.$message.error('发布失败')
      } finally {
        this.publishing = false
      }
    },
    
    async unpublishReport() {
      try {
        await this.$confirm('取消发布后客户门户将无法查看该报告，确定吗？', '取消发布', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          customClass: 'publish-confirm-dialog'
        })
      } catch {
        return
      }
      this.publishing = true
      try {
        const res = await axios.post('/Report/unpublish', {
          ProjectId: this.projectId,
          FormKey: this.formKey
        })
        const data = res.data?.data || res.data
        if (data && !data.errcode) {
          this.$message.success('已取消发布')
          // 直接更新发布状态，避免 loadData 重置展开的门店详情
          if (this.snapshotInfo) {
            this.snapshotInfo.isPublished = false
            this.snapshotInfo.publishTime = null
          }
        } else {
          this.$message.error(data?.message || '操作失败')
        }
      } catch (e) {
        console.error(e)
        this.$message.error('操作失败')
      } finally {
        this.publishing = false
      }
    },
    
    exportExcel() {
      if (!this.displayData || this.displayData.length === 0) {
        this.$message.warning('暂无数据可导出')
        return
      }
      
      // 构建表头
      const segCols = this.topLevelSegments.map(s => s.segmentName)
      const headers = ['类型', '名称', '门店数', '总体得分', '全国排名', '战区排名', ...segCols]
      
      // 构建数据行
      const typeMap = { national: '全国', daqu: '战区', xiaoqu: '小区', store: '门店' }
      const rows = this.displayData.map(row => {
        const base = [
          typeMap[row.rowType] || row.rowType,
          row.name,
          row.rowType !== 'store' ? row.storeCount : '-',
          row.avgScore,
          row.rowType === 'store' ? (row.daquRankInNational || '-') : (row.rowType === 'daqu' ? `${row.rank}/${row.rankTotal}` : '-'),
          row.rowType === 'store' ? (row.xiaoquRankInDaqu || '-') : (row.rowType === 'xiaoqu' ? `${row.rank}/${row.rankTotal}` : '-')
        ]
        // 一级指标分数
        const segScores = this.topLevelSegments.map(col => this.getSegmentScore(row, col.segmentKey))
        return [...base, ...segScores]
      })
      
      // 生成 workbook
      const ws = XLSX.utils.aoa_to_sheet([headers, ...rows])
      // 设置列宽
      ws['!cols'] = headers.map((h, i) => ({ wch: i <= 1 ? 20 : 12 }))
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, '单店报告')
      XLSX.writeFile(wb, `单店报告_${new Date().toLocaleDateString('zh-CN').replace(/\//g, '-')}.xlsx`)
      this.$message.success('导出成功')
    },
    
    handleFilter() {
      if (!this.filterKeyword) {
        this.displayData = [...this.rawData]
        return
      }
      
      const keyword = this.filterKeyword.toLowerCase()
      
      // 平铺数据的简单过滤
      this.displayData = this.rawData.filter(row => {
        const nameMatch = row.name && row.name.toLowerCase().includes(keyword)
        const codeMatch = row.code && row.code.toLowerCase().includes(keyword)
        const parentMatch = (row.parentDaquName && row.parentDaquName.toLowerCase().includes(keyword)) ||
                           (row.parentXiaoquName && row.parentXiaoquName.toLowerCase().includes(keyword))
        return nameMatch || codeMatch || parentMatch
      })
    },
    
    async handleExpandChange(row, expandedRows) {
      if (expandedRows.find(r => r.uniqueId === row.uniqueId) && !row.segmentTree) {
        this.$set(row, 'detailLoading', true)
        try {
          if (row.rowType === 'store') {
            // 紧急修复策略：对于 store 类型，我们调用 Report/store/list 搜索该门店获取 answerKey
            const listRes = await axios.post('/Report/store/list', {
                ProjectId: this.projectId,
                FormKey: this.formKey,
               StoreName: row.name
            })
            const listData = listRes.data?.data || listRes.data
            if (listData && listData.records && listData.records.length > 0) {
                 const target = listData.records[0] // 近似匹配
                 // 调用详情
                 const detailRes = await axios.post('/Report/store/detail', {
                    ProjectId: this.projectId,
                    FormKey: this.formKey,
                    AnswerKey: target.answerKey,
                    StoreCode: target.storeCode
                 })
                 const detailData = detailRes.data?.data || detailRes.data
                 this.processSegmentData(row, detailData.segments)
                 // 补充排名信息
                 this.$set(row, 'rankInXiaoqu', target.rankInXiaoqu)
                 this.$set(row, 'xiaoquRankInDaqu', target.xiaoquRankInDaqu)
                 this.$set(row, 'daquRankInNational', target.daquRankInNational)
            }
          } else {
            // 区域/全国聚合详情
            const detailRes = await axios.post('/Report/region/detail', {
                ProjectId: this.projectId,
                FormKey: this.formKey,
                Level: row.rowType === 'national' ? 0 : (row.rowType === 'daqu' ? 2 : 3),
                Id: row.id // DaquId or XiaoquId
            })
            const detailData = detailRes.data?.data || detailRes.data
            this.processSegmentData(row, detailData.segments)
          }
        } catch (e) {
          console.error(e)
          this.$message.error('加载详情失败')
        } finally {
          this.$set(row, 'detailLoading', false)
        }
      }
    },
    
    processSegmentData(row, segments) {
      if (!segments) return
      
      // 调试日志：检查API返回的原始数据结构
      console.log('[StoreReport] Raw segments from API:', JSON.stringify(segments, null, 2))
      
      // 递归设置所有节点为展开状态（包括有items的叶子节点）
      // 兼容 PascalCase 和 camelCase
      const initExpand = (segs) => {
        return segs.map(seg => {
          const items = seg.items || seg.Items || []
          const children = seg.children || seg.Children || []
          console.log(`[StoreReport] Segment "${seg.segmentName || seg.SegmentName}": children=${children.length}, items=${items.length}`)
          return {
            ...seg,
            expanded: true, // 默认全部展开
            children: children.length ? initExpand(children) : [],
            items: items.map(item => ({
              itemKey: item.itemKey || item.ItemKey,
              label: item.label || item.Label,
              targetScore: item.targetScore || item.TargetScore || 0,
              actualScore: item.actualScore || item.ActualScore || 0,
              scoreRate: item.scoreRate || item.ScoreRate || 0
            }))
          }
        })
      }
      this.$set(row, 'segmentTree', initExpand(segments))
    },
    
    toggleSegmentExpand(seg) {
      this.$set(seg, 'expanded', seg.expanded === false ? true : false)
    },
    
    getSegmentScore(row, segKey) {
       // 顶层分数从 SegmentScores 字典拿 (RegionalRow)
       if (row.segmentScores && row.segmentScores[segKey] !== undefined) {
           return row.segmentScores[segKey]
       }
       // 或者从 summary (StoreListItem)
       if (row.segmentScores && Array.isArray(row.segmentScores)) {
           const match = row.segmentScores.find(s => s.segmentKey === segKey)
           return match ? match.score : '-'
       }
       // 从 segmentTree 中查找 (如果已加载)
       if (row.segmentTree) {
           const match = row.segmentTree.find(s => s.segmentKey === segKey)
           if (match) return match.actualScore
       }
       return '-'
    },
    
    getStatusIcon(rate) {
      if (rate >= 90) return '✅'
      if (rate >= 80) return '✅'
      if (rate >= 60) return '⚠️'
      return '❌'
    },
    
    getScoreClass(score) {
      if (!score) return ''
      const num = parseFloat(score)
      if (num >= 90) return 'text-success'
      if (num >= 80) return 'text-primary'
      if (num >= 60) return 'text-warning'
      return 'text-danger'
    },
    scoreMethodLabel(method) {
      const map = { sum: '求和', average: '平均分', weighted: '加权', percentage: '百分制' }
      return map[(method || 'sum').toLowerCase()] || '求和'
    }
  }
}

function stringIsNullOrEmpty(str) {
    return !str || str === ''
}
</script>

<style scoped>
.store-report {
  padding: 24px;
  background: #f5f7fa;
  min-height: 100vh;
}

/* ========== 报告类型切换 ========== */
.report-type-group {
  margin-bottom: 16px;
}
.report-type-group ::v-deep .el-radio-group {
  background: rgba(243, 244, 246, 0.5);
  border-radius: 12px;
  padding: 4px;
  display: inline-flex;
  gap: 4px;
}
.report-type-group ::v-deep .el-radio-button__inner {
  border: none !important;
  border-radius: 8px !important;
  background: transparent !important;
  box-shadow: none !important;
  color: #6b7280;
  font-size: 14px;
  font-weight: 500;
  padding: 8px 24px;
  transition: all .2s;
}
.report-type-group ::v-deep .el-radio-button__inner:hover {
  color: #374151;
  background: rgba(249, 250, 251, 0.5) !important;
}
.report-type-group ::v-deep .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  color: #2563eb !important;
  background: #fff !important;
  box-shadow: 0 1px 2px rgba(0,0,0,.05) !important;
  font-weight: 600;
}
.report-type-group ::v-deep .el-radio-button:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio-button__inner {
  box-shadow: none !important;
}

/* 波次多选 */
.wave-checkbox-group {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-left: 12px;
}
.wave-checkbox-group .el-checkbox {
  margin-right: 0 !important;
}

/* ========== 报告卡片容器 ========== */
.report-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  border: 1px solid #f3f4f6;
  overflow: hidden;
}

/* ========== 头部 ========== */
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px;
  border-bottom: 1px solid #f9fafb;
}
.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}
.header-icon-gradient {
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, #a78bfa, #3b82f6);
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.header-icon-svg {
  width: 20px;
  height: 20px;
  color: #fff;
}
.header-left h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: #1f2937;
  white-space: nowrap;
}
.header-right {
  display: flex;
  align-items: center;
  gap: 12px;
}
/* 按钮内 SVG 图标 */
.btn-icon {
  width: 16px;
  height: 16px;
  margin-right: 6px;
  vertical-align: middle;
  display: inline-block;
}
.refresh-icon-svg {
  width: 16px;
  height: 16px;
}

/* 头部控件样式 */
.header-select ::v-deep .el-input__inner {
  border-radius: 8px !important;
  height: 38px !important;
  line-height: 38px !important;
  border-color: #e5e7eb !important;
  font-size: 14px !important;
  width: 180px;
}
.header-search ::v-deep .el-input__inner {
  border-radius: 8px !important;
  height: 38px !important;
  line-height: 38px !important;
  border-color: #e5e7eb !important;
  font-size: 14px !important;
  width: 200px;
}
.btn-generate {
  border-radius: 8px !important;
  height: 38px !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  padding: 0 20px !important;
  background-color: #2563eb !important;
  border-color: #2563eb !important;
}
.btn-generate:hover {
  background-color: #1d4ed8 !important;
  border-color: #1d4ed8 !important;
}
.btn-export {
  border-radius: 8px !important;
  height: 38px !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  padding: 0 16px !important;
  border-color: #d1d5db !important;
  color: #374151 !important;
}
.btn-export:hover {
  color: #3b82f6 !important;
  border-color: #3b82f6 !important;
}
.btn-publish {
  border-radius: 8px !important;
  height: 38px !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  padding: 0 16px !important;
  background-color: #10b981 !important;
  border-color: #10b981 !important;
  color: #fff !important;
}
.btn-publish:hover {
  background-color: #059669 !important;
  border-color: #059669 !important;
}
.btn-unpublish {
  border-radius: 8px !important;
  height: 38px !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  padding: 0 16px !important;
}
.btn-refresh-icon {
  width: 38px !important;
  min-width: 38px !important;
  max-width: 38px !important;
  height: 38px !important;
  font-size: 16px !important;
  padding: 0 !important;
  border-radius: 8px !important;
  border-color: #e5e7eb !important;
  color: #4b5563 !important;
  background: transparent !important;
}
.btn-refresh-icon:hover {
  color: #2563eb !important;
  border-color: #2563eb !important;
  background: #f9fafb !important;
}

/* ========== 快照信息 ========== */
.snapshot-info {
  padding: 12px 24px;
  margin-bottom: 20px;
  color: #3b82f6;
  font-size: 13px;
  font-weight: 500;
  background: transparent;
  border: none;
}
.snapshot-info i {
  margin-right: 6px;
}

/* ========== 统计卡片 ========== */
.stats-bar {
  display: flex;
  gap: 20px;
  margin-bottom: 24px;
}
.stat-card {
  background: #fff;
  padding: 32px 40px;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
}
.stat-value {
  font-size: 40px;
  font-weight: 700;
  color: #3b82f6;
  margin-bottom: 8px;
  line-height: 1;
}
.stat-label {
  color: #9ca3af;
  font-size: 14px;
  font-weight: 400;
}

/* ========== 表格区域 ========== */
.report-content {
  background: #fff;
  border-radius: 12px;
  padding: 0;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
  overflow: hidden;
}

/* 表格无边框无条纹 */
.custom-table ::v-deep .el-table__header-wrapper th {
  background: #fff !important;
  color: #9ca3af !important;
  font-weight: 500 !important;
  font-size: 13px !important;
  border-right: none !important;
  border-bottom: 1px solid #f0f0f0 !important;
  padding: 14px 0 !important;
}
.custom-table ::v-deep .el-table__row td {
  border-bottom: 1px solid #f0f0f0 !important;
  border-right: none !important;
  padding: 0 !important;
  height: auto !important;
}
.custom-table ::v-deep .el-table--striped .el-table__body tr.el-table__row--striped td {
  background: transparent !important;
}
.custom-table ::v-deep .el-table__body tr:hover > td {
  background-color: #fafbfc !important;
}
.custom-table ::v-deep .el-table--border,
.custom-table ::v-deep .el-table--border td,
.custom-table ::v-deep .el-table--border th {
  border-right: none !important;
}
.custom-table ::v-deep .el-table--border::after,
.custom-table ::v-deep .el-table--group::after,
.custom-table ::v-deep .el-table::before {
  display: none !important;
}
.custom-table ::v-deep .el-table {
  border: none !important;
}
.custom-table ::v-deep .el-table td,
.custom-table ::v-deep .el-table th {
  border-right: none !important;
}

/* 名称列 */
.name-cell {
  display: flex;
  align-items: center;
  padding: 8px 0;
}
.type-icon {
  margin-right: 8px;
  font-size: 16px;
}
.name-text {
  font-weight: 600;
  font-size: 14px;
}
.row-type-national .name-text { color: #1f2937; font-weight: 700; font-size: 15px; }
.row-type-daqu .name-text { color: #3b82f6; }
.row-type-xiaoqu .name-text { color: #22c55e; }
.row-type-store .name-text { color: #374151; font-weight: 500; }

/* 分数 */
.score-text {
  font-weight: 700;
  font-size: 15px;
}
.text-success { color: #22c55e; }
.text-primary { color: #3b82f6; }
.text-warning { color: #f59e0b; }
.text-danger { color: #ef4444; }

/* ========== 展开详情 ========== */
.expand-wrapper {
  padding: 24px 28px;
  background: #fafbfc;
}
.detail-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e5e7eb;
}
.detail-title {
  font-size: 16px;
  font-weight: 700;
  color: #1f2937;
  display: flex;
  align-items: center;
}
.detail-title i { margin-right: 8px; color: #3b82f6; font-size: 18px; }
.detail-tag { font-size: 14px; color: #9ca3af; margin-left: 8px; font-weight: 400; }
.detail-subtitle {
  font-size: 12px;
  color: #6b7280;
  background: #f3f4f6;
  padding: 6px 14px;
  border-radius: 6px;
  white-space: nowrap;
}

/* 算法说明 */
.algorithm-note {
  background: #eff6ff;
  border: 1px solid #dbeafe;
  border-radius: 8px;
  padding: 12px 18px;
  margin-bottom: 16px;
  font-size: 13px;
  color: #3b82f6;
}
.algorithm-note i {
  margin-right: 8px;
}
.algorithm-note strong {
  color: #1d4ed8;
}

/* 环节得分表 */
.segment-table-container {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
}
.segment-table {
  width: 100%;
  border-collapse: collapse;
}
.segment-table th {
  background: #f9fafb;
  padding: 12px 16px;
  color: #6b7280;
  font-weight: 500;
  font-size: 13px;
  border-bottom: 1px solid #e5e7eb;
  text-align: left;
}
.segment-table th.text-center { text-align: center; }
.segment-table td {
  padding: 12px 16px;
  border-bottom: 1px solid #f0f0f0;
  color: #374151;
  font-size: 14px;
}
.segment-table tr:last-child td { border-bottom: none; }

.level-1 { cursor: pointer; background: #fff; font-weight: 600; }
.level-1:hover { background: #f8fafc; }
.level-2 { cursor: pointer; }
.level-2:hover { background: #f8fafc; }
.level-3 { color: #6b7280; cursor: pointer; }
.level-3:hover { background: #fafbfc; }
.level-item { background: #fafafa; }

.col-name { position: relative; }
.expand-icon {
  display: inline-block;
  width: 24px;
  text-align: center;
  color: #9ca3af;
  margin-right: 4px;
  font-size: 12px;
}
.icon { margin-right: 6px; opacity: 0.85; }
.item-count { color: #9ca3af; font-size: 12px; margin-left: 4px; font-weight: 400; }
.indent-2 { display: inline-block; width: 20px; margin-left: 24px; }
.indent-3 { display: inline-block; width: 20px; margin-left: 48px; }
.indent-4 { display: inline-block; width: 20px; margin-left: 72px; }

.item-row { 
  font-size: 13px;
  color: #6b7280;
  background: #fafafa;
}
.item-label {
  max-width: 400px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  vertical-align: middle;
}

.text-center { text-align: center; }
.text-muted { color: #9ca3af; }

/* 空状态 */
.empty-tip {
  text-align: center;
  padding: 100px 0;
  color: #9ca3af;
}
.empty-tip i { font-size: 48px; margin-bottom: 20px; color: #d1d5db; display: block; }

/* ========== 发布弹窗 ========== */
::v-deep .publish-dialog {
  border-radius: 12px !important;
  overflow: hidden;
}
::v-deep .publish-dialog .el-dialog__header {
  padding: 20px 24px 16px;
  border-bottom: none;
}
::v-deep .publish-dialog .el-dialog__title {
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
}
::v-deep .publish-dialog .el-dialog__headerbtn {
  top: 20px;
  right: 20px;
}
::v-deep .publish-dialog .el-dialog__body {
  padding: 0 24px;
}
::v-deep .publish-dialog .el-dialog__footer {
  padding: 16px 24px 20px;
  border-top: none;
}
</style>

<style>
/* 取消发布确认弹窗样式（MessageBox 渲染在 body 下，需要全局样式） */
.publish-confirm-dialog {
  border-radius: 12px !important;
  overflow: hidden;
  width: 420px !important;
  padding-bottom: 0 !important;
}
.publish-confirm-dialog .el-message-box__header {
  padding: 20px 24px 10px;
}
.publish-confirm-dialog .el-message-box__title {
  font-size: 16px;
  font-weight: 600;
  color: #1f2937;
}
.publish-confirm-dialog .el-message-box__headerbtn {
  top: 16px;
  right: 16px;
}
.publish-confirm-dialog .el-message-box__content {
  padding: 10px 24px 20px;
  font-size: 14px;
  color: #374151;
}
.publish-confirm-dialog .el-message-box__btns {
  padding: 0 24px 20px;
}
.publish-confirm-dialog .el-message-box__btns .el-button {
  border-radius: 8px !important;
  height: 38px !important;
  padding: 0 24px !important;
  font-size: 14px !important;
}
.publish-confirm-dialog .el-message-box__btns .el-button--primary {
  background: #3b82f6 !important;
  border-color: #3b82f6 !important;
  font-weight: 600 !important;
}
.publish-confirm-dialog .el-message-box__btns .el-button--primary:hover {
  background: #2563eb !important;
  border-color: #2563eb !important;
}
</style>

<style scoped>
.publish-form {
  padding: 10px 0;
}
.publish-form-row {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  gap: 16px;
}
.publish-form-row:last-child {
  flex-wrap: wrap;
}
.publish-label {
  flex-shrink: 0;
  font-size: 14px;
  color: #374151;
  min-width: 70px;
}
.publish-label.required::before {
  content: '*';
  color: #f56c6c;
  margin-right: 4px;
}
.publish-value {
  font-size: 14px;
  color: #1f2937;
}
.publish-select {
  flex: 1;
}
.publish-select ::v-deep .el-input__inner {
  border-radius: 8px !important;
  height: 40px !important;
  line-height: 40px !important;
}
.publish-tip {
  width: 100%;
  color: #f56c6c;
  font-size: 12px;
  margin-top: -16px;
  padding-left: 86px;
}
.publish-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
.publish-btn-cancel {
  border-radius: 8px !important;
  height: 38px !important;
  padding: 0 24px !important;
  font-size: 14px !important;
  border-color: #d1d5db !important;
  color: #374151 !important;
}
.publish-btn-confirm {
  border-radius: 8px !important;
  height: 38px !important;
  padding: 0 24px !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  background: #3b82f6 !important;
  border-color: #3b82f6 !important;
}
.publish-btn-confirm:hover {
  background: #2563eb !important;
  border-color: #2563eb !important;
}

/* 算分方式标签 */
.score-method-tag {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 500;
  background: #eff6ff;
  color: #3b82f6;
  border: 1px solid #bfdbfe;
}
</style>

